import PopUpWarning from '@components/PopUpWarning';
import { pushSuccess } from '@components/toast';
import { geoZoneController } from '@controllers/index';
import { CameraType } from '@EcamModel/controllers/ICameraHttpController';
import { GeoZones } from '@EcamModel/model';
import usePopUp from '@hooks/usePopUp';
import { Box, Button, Stack, Typography } from '@mui/material';
import color from '@theme/Colors';
import { useState } from 'react';
import { typeTextMap } from '../../../../hook/GeoZonesNavigateHandler';
import { useCameraDetailContext } from '../../../../hook/CameraDetailsProvider';
import BaseTableGeoZonesDetail from '../components/BaseTableGeoZonesDetail';
import WrapHistoryPhoto from './components/HistoriesPhoto';
import { useQueryClient } from 'react-query';
import useMedia from '@hooks/useMedia';

export type Mode = 'create' | 'edit';

export default function GeoZonesDetailSolar({ cameraType }: { cameraType: CameraType }) {
    const { navigate, setCamera, camera, blobLatestPhoto } = useCameraDetailContext();
    const queryClient = useQueryClient();
    const popUpWarning = usePopUp();
    const { isMediumMD, isMobileSM } = useMedia();

    const [selectedGeoZone, setSelectedGeoZone] = useState<GeoZones>({} as GeoZones);

    return (
        <Box padding={2} borderRadius={2} bgcolor={color.grey100}>
            <WrapHistoryPhoto isHideAction={!!camera.Deleted} cameraType={cameraType} />
            <Stack bgcolor={color.white} padding={2} borderRadius={2} mt={2}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography color={color.darkPrimary} variant="h5" width={'100%'}>
                        Geo-zones
                    </Typography>
                    {!camera.Deleted && (
                        <Button
                            variant="contained"
                            sx={{ flexBasis: 185 }}
                            onClick={() => {
                                setSelectedGeoZone({} as GeoZones);
                                navigate(`add/${typeTextMap[cameraType]}`, {
                                    state: {
                                        selectedGeoZone: selectedGeoZone,
                                    },
                                });
                            }}
                            disabled={
                                (camera.VendorCameraId !== null && Boolean(camera.GeoZones?.length === 4)) ||
                                !blobLatestPhoto
                            }
                        >
                            Add geo-zone
                        </Button>
                    )}
                </Stack>

                <BaseTableGeoZonesDetail
                    rows={camera.GeoZones || []}
                    cameraDeleted={!camera.Deleted}
                    locationName={camera.Zone?.Location?.Name}
                    zoneName={camera.Zone?.PublicName}
                    handleDelete={(item) => {
                        setSelectedGeoZone(item);
                        popUpWarning.setTrue();
                    }}
                    handleEdit={(item) => {
                        setSelectedGeoZone(item);
                        navigate(`edit/${item.Id}/${typeTextMap[cameraType]}`, {
                            state: {
                                selectedGeoZone: item,
                            },
                        });
                    }}
                />

                <PopUpWarning
                    {...popUpWarning}
                    title="Confirm"
                    message="Are you sure you want to delete this geo-zone?"
                    onConfirm={() => {
                        geoZoneController.delete(selectedGeoZone.Id?.toString()!).then((res) => {
                            queryClient.invalidateQueries(['trailAuditEvent']);
                            setCamera((prev) => ({
                                ...prev,
                                GeoZones: prev.GeoZones?.filter((item) => item.Id !== selectedGeoZone.Id),
                            }));
                            pushSuccess('Deleted geo-zone successfully');
                            popUpWarning.onClose();
                        });
                    }}
                />
            </Stack>
        </Box>
    );
}
